<template>
  <div class="treeview table-bg">
    <div class="treeview-header" :class="treeType === 'device' ? 'device' : ''">
      <div class="search">
        <input type="search" placeholder="사업자번호/회사명 으로 검색" v-model="searchValue" @keyup.enter="search(1)">
      </div>
      <div class="search" v-if="treeType === 'device'">
        <input type="search" placeholder="주소/장소로 검색" v-model="searchValue2" @keyup.enter="search(2)">
      </div>
    </div>
    <div class="tree-list">
      <div v-if="treeType === 'division'" class="frame-treeview" :class="treeData.isSelected ? 'box-treeview-select' : ''">
        <div class="first">
          <div class="arrow" :class="treeData.isOpen ? 'open' : ''">
            <img src="/static/img/ico-arrow-S-gray@2x.png" alt @click="openFold(treeData)"/>
          </div>
          <div class="icon">
            <img :src="treeData.isSelected ? '/static/img/ico-menu-8-blue@2x.png' : '/static/img/ico-menu-8@2x.png'"/>
          </div>
          <div class="text" @click="selectNode(treeData, 'all')">{{ treeData.name }} ({{ treeData.children.length }})</div>
        </div>
      </div>
      <div v-if="treeData.folder && treeData.isOpen">
        <div class="company" v-for="company in treeData.children" :key="company.id">
          <div class="frame-treeview" :class="company.isSelected ? 'box-treeview-select' : ''">
            <div :class="treeType === 'division' ? 'second' : 'first'">
              <div class="arrow" :class="company.isOpen ? 'open' : ''">
                <img src="/static/img/ico-arrow-S-gray@2x.png" alt @click="openFold(company)"/>
              </div>
              <div class="icon">
                <img :src="company.isSelected ? '/static/img/ico-menu-8-blue@2x.png' : '/static/img/ico-menu-8@2x.png'"/>
              </div>
              <div class="text" @click="selectNode(company, 'company')">{{ company.name }} <span v-if="treeType !== 'company'">({{ company.children.length }})</span></div>
            </div>
          </div>
          <div v-if="(treeType === 'division') && company.folder && company.isOpen">
            <div class="division" v-for="division in company.children" :key="division.id">
              <div class="frame-treeview" :class="division.isSelected ? 'box-treeview-select' : ''">
                <div class="third">
                  <div class="icon">
                    <img :src="division.isSelected ? '/static/img/ico-menu-8-blue@2x.png' : '/static/img/ico-menu-8@2x.png'"/>
                  </div>
                  <div class="text" @click="selectNode(division, 'division')">{{ division.name }} <span v-if="treeType !== 'division'">({{ division.children.length }})</span></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="(treeType === 'device') && company.folder && company.isOpen">
            <div class="device" v-for="device in company.children" :key="device.id">
              <div class="frame-treeview" :class="device.isSelected ? 'box-treeview-select' : ''">
                <div class="second">
                  <div class="icon">
                    <img :src="device.isSelected ? '/static/img/ico-place-blue@2x.png' : '/static/img/ico-place@2x.png'"/>
                  </div>
                  <div v-if="treeType === 'device'" @click="selectNode(device, 'device')">
                    <div class="tooltip">{{ device.name }}<span class="tooltiptext">{{ device.id}}</span></div>
                  </div>
                  <div v-else @click="selectNode(device, 'device')">{{ device.name}} ({{ device.children.length }})</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable no-continue */

import Configuration from '@/js/Configuration';

export default {
  props: [
    'treeType',
    'treeScope',
    'companyID',
    'refreshEvent',
  ],
  data: () => ({
    treeData: {
      id: 1,
      name: '전체',
      alias: 'root',
      pID: null,
      pName: null,
      pAlias: null,
      folder: true,
      isOpen: true,
      isSelected: true,
      children: [],
    },
    isOpen: false,
    selectedNode: null,
    scope: null,
    role: null,
    currentCompanyID: null,
    currentParentCompanyID: null,
    searchValue: null,
    searchValue2: null,
  }),
  created() {
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.scope = token.scope;
    this.role = token.role;
    this.currentCompanyID = token.companyID;
    this.currentParentCompanyID = token.parentCompanyID;

    this.fetch();
  },
  watch: {
    refreshEvent() {
      this.fetch();
    },
  },
  methods: {
    async fetch() {
      this.treeData = {
        id: 0,
        name: '전체',
        alias: 'root',
        pID: null,
        pName: null,
        pAlias: null,
        folder: true,
        isOpen: true,
        isSelected: true,
        children: [],
      };
      if (!this.selectedNode) {
        this.selectedNode = this.treeData;
      }

      if (this.treeScope === 'biz' && this.scope === 4) {
        this.treeData.children = await this.getParentCompanyData();
      } else if (!this.companyID) {
        this.treeData.children = await this.getCompanyList();
      } else {
        this.treeData.children = await this.getCompanyData();
      }

      if (this.treeType === 'division') {
        await this.fetchDivisonData(this.treeData.children);
      } else if (this.treeType === 'device') {
        await this.fetchDeviceData(this.treeData.children);
      }
    },
    async getCompanyList() {
      let companyList = [];

      try {
        const listURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/list?page=1&limit=500`;

        const list = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          if (list.status === 204) {
            companyList = [];
            return companyList;
          }

          throw new Error(`response status is "${list.status}"`);
        }
        if (list.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${list.data.resultCode}"`);
        }

        for (let i = 0; i < list.data.companies.length; i++) {
          const p = list.data.companies[i];

          // check view scope
          if (this.treeScope === 'cs' && p.scope !== 2) {
            continue;
          } else if (this.treeScope === 'biz' && p.scope !== 3) {
            continue;
          } else if (this.treeScope === 'device' && p.scope !== 4) {
            continue;
          }

          // check current scope
          if (this.role !== 1 && this.role !== 5) {
            if (this.scope === 2 && this.currentCompanyID === p.parentCompanyID) {
              // WARNING: cs 는 자식 biz 를 볼 수 있다. pass
            } else if (this.currentCompanyID !== p.companyID) {
              continue;
            }
          }

          const company = {
            id: p.companyID,
            name: p.companyName,
            alias: p.companyAlias,
            pID: 1,
            pName: '전체',
            pAlias: 'root',
            registrationNo: p.registrationNo,
            scope: p.scope,
            folder: false,
            isOpen: true,
            isSelected: false,
            children: [],
          };
          if (this.selectedNode.id === company.id) {
            company.isSelected = true;
            this.treeData.isSelected = false;
          }

          companyList.push(company);
        }
      } catch (e) {
        companyList = [];
        console.error(e);
      }
      return companyList;
    },
    async getCompanyData() {
      let companyList = [];

      try {
        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/${this.companyID}?withDivisions=false`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (result.status !== 200) {
          if (result.status === 204) {
            companyList = [];
            return companyList;
          }

          throw new Error(`response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${result.data.resultCode}"`);
        }

        const company = {
          id: result.data.company.companyID,
          name: result.data.company.companyName,
          alias: result.data.company.companyAlias,
          pID: 1,
          pName: '전체',
          pAlias: 'root',
          registrationNo: result.data.company.registrationNo,
          scope: result.data.company.scope,
          folder: false,
          isOpen: true,
          isSelected: false,
          children: [],
        };
        if (this.selectedNode.id === company.id) {
          company.isSelected = true;
          this.treeData.isSelected = false;
        }
        companyList.push(company);
      } catch (e) {
        companyList = [];
        console.error(e);
      }
      return companyList;
    },
    async getParentCompanyData() {
      let companyList = [];

      try {
        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/${this.currentCompanyID}?withDivisions=false`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (result.status !== 200) {
          if (result.status === 204) {
            companyList = [];
            return companyList;
          }

          throw new Error(`response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${result.data.resultCode}"`);
        }

        const parentCompanyID = result.data.company.parentCompanyID;

        try {
          const getParentCompanyURL = `${Configuration.value(
            'CACCOUNT_ADDRESS',
          )}/api/v1/caccount/company/${parentCompanyID}?withDivisions=false`;

          const parentResult = await this.$http.get(getParentCompanyURL, {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
          if (parentResult.status !== 200) {
            if (parentResult.status === 204) {
              companyList = [];
              return companyList;
            }

            throw new Error(`response status is "${parentResult.status}"`);
          }
          if (parentResult.data.resultCode !== '0000') {
            throw new Error(`resultcode is "${parentResult.data.resultCode}"`);
          }

          const company = {
            id: parentResult.data.company.companyID,
            name: parentResult.data.company.companyName,
            alias: parentResult.data.company.companyAlias,
            pID: 1,
            pName: '전체',
            pAlias: 'root',
            registrationNo: parentResult.data.company.registrationNo,
            scope: parentResult.data.company.scope,
            folder: false,
            isOpen: true,
            isSelected: false,
            children: [],
          };
          if (this.selectedNode.id === company.id) {
            company.isSelected = true;
            this.treeData.isSelected = false;
          }
          companyList.push(company);
        } catch (pe) {
          companyList = [];
          console.error(pe);
        }
      } catch (e) {
        companyList = [];
        console.error(e);
      }
      return companyList;
    },
    async fetchDivisonData(companies) {
      const list = [];
      for (let i = 0; i < companies.length; i++) {
        const ba = this.getDivisonData(companies[i]);
        list.push(ba);
      }
      return Promise.all(list);
    },
    async getDivisonData(value) {
      let divisionList = [];

      try {
        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/${value.id}?withDivisions=true`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });

        if (result.status === 200 && result.data.resultCode === '0000' && result.data.company.divisions) {
          for (let i = 0; i < result.data.company.divisions.length; i++) {
            const d = result.data.company.divisions[i];

            const division = {
              id: d.divisionID,
              name: d.divisionName,
              alias: d.divisionAlias,
              pID: value.id,
              pName: value.name,
              pAlias: value.alias,
              folder: false,
              isOpen: true,
              isSelected: false,
              children: [],
            };

            if (this.selectedNode.id === division.id) {
              division.isSelected = true;
              this.treeData.isSelected = false;
            }
            divisionList.push(division);
          }
          value.children = divisionList;
          if (divisionList.length > 0) value.folder = true;
        }
      } catch (e) {
        divisionList = [];
        console.error(e);
      }

      return divisionList;
    },
    async fetchDeviceData(companies) {
      const list = [];
      for (let i = 0; i < companies.length; i++) {
        const ba = this.getDeviceData(companies[i]);
        list.push(ba);
      }
      return Promise.all(list);
    },
    async getDeviceData(value) {
      let deviceList = [];

      try {
        const getURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/list?page=1&limit=500&companyID=${value.id}`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });

        if (result.status === 200 && result.data.resultCode === '0000') {
          for (let i = 0; i < result.data.devices.length; i++) {
            const d = result.data.devices[i];

            const device = {
              id: d.deviceID,
              name: d.deviceName,
              alias: d.deviceAlias,
              pID: value.id,
              pName: value.name,
              pAlias: value.alias,
              folder: false,
              isOpen: true,
              isSelected: false,
              children: [],
            };
            if (this.selectedNode.id === device.id) {
              device.isSelected = true;
              this.treeData.isSelected = false;
            }
            deviceList.push(device);
          }
          value.children = deviceList;
          if (deviceList.length > 0) value.folder = true;
        }
      } catch (e) {
        deviceList = [];
        console.error(e);
      }

      return deviceList;
    },
    allOpen() {
      this.treeData.isOpen = true;
      for (let i = 0; i < this.treeData.children.length; i++) {
        const company = this.treeData.children[i];
        company.isOpen = true;
        for (let j = 0; j < company.children.length; j++) {
          const division = company.children[j];
          division.isOpen = true;
          for (let k = 0; k < division.children.length; k++) {
            const user = division.children[j];
            user.isOpen = true;
          }
        }
      }
    },
    allClose() {
      this.treeData.isOpen = false;
      for (let i = 0; i < this.treeData.children.length; i++) {
        const company = this.treeData.children[i];
        company.isOpen = false;
        for (let j = 0; j < company.children.length; j++) {
          const division = company.children[j];
          division.isOpen = false;
          for (let k = 0; k < division.children.length; k++) {
            const user = division.children[j];
            user.isOpen = false;
          }
        }
      }
    },
    openFold(object) {
      if (object.folder) {
        object.isOpen = !object.isOpen;
      }
    },
    selectNode(object, type) {
      if (!object.isOpen) object.isOpen = true;
      const selectedNode = this.findSelectedNode(this.selectedNode);
      selectedNode.isSelected = false;
      object.isSelected = true;
      this.selectedNode = object;
      this.$emit('selectNode', object, type);
    },
    findSelectedNode(node) {
      if (this.treeData.id === node.id) {
        return this.treeData;
      } else if (this.treeData.children) {
        for (let i = 0; i < this.treeData.children.length; i++) {
          const child1 = this.treeData.children[i];
          if (child1.id === node.id) {
            return child1;
          } else if (child1.children) {
            for (let j = 0; j < child1.children.length; j++) {
              const child2 = child1.children[j];
              if (child2.id === node.id) {
                return child2;
              }
            }
          }
        }
      }
      return null;
    },
    async search(type) {
      if ((!this.searchValue || this.searchValue.length === 0) && (!this.searchValue2 || this.searchValue2.length === 0)) {
        this.fetch();
        return;
      } else if (type === 1 && (!this.searchValue || this.searchValue.length === 0) && (this.searchValue2 && this.searchValue2.length > 0)) {
        this.search(2);
      } else if (type === 2 && (this.searchValue && this.searchValue.length > 0) && (!this.searchValue2 || this.searchValue2.length === 0)) {
        this.search(1);
      }

      if (type === 1) {
        let pCompanyList = [];
        if (this.treeScope === 'biz' && this.scope === 4) {
          pCompanyList = await this.getParentCompanyData();
        }

        const companyList = [];
        const list = await this.$searchCompany(1, 500, this.searchValue);
        if (list) {
          for (let i = 0; i < list.length; i++) {
            const p = list[i];

            // check view scope
            if (this.treeScope === 'cs' && p.scope !== 2) {
              continue;
            } else if (this.treeScope === 'biz' && p.scope !== 3) {
              continue;
            } else if (this.treeScope === 'device' && p.scope !== 4) {
              continue;
            }

            // check current scope
            if (this.role !== 1 && this.role !== 5) {
              if (this.treeScope === 'biz' && this.scope === 4) {
                let found = false;
                for (let j = 0; j < pCompanyList.length; j++) {
                  if (pCompanyList[j].id === p.companyID) {
                    found = true;
                    break;
                  }
                }
                if (!found) {
                  continue;
                }
              } else if (this.currentCompanyID !== p.companyID) {
                continue;
              }
            }

            const company = {
              id: p.companyID,
              name: p.companyName,
              alias: p.companyAlias,
              pID: 1,
              pName: '전체',
              pAlias: 'root',
              registrationNo: p.registrationNo,
              scope: p.scope,
              folder: false,
              isOpen: true,
              isSelected: false,
              children: [],
            };

            companyList.push(company);
          }
        }
        this.treeData.children = companyList;
        if (this.treeType === 'division') {
          await this.fetchDivisonData(this.treeData.children);
        } else if (this.treeType === 'device') {
          await this.fetchDeviceData(this.treeData.children);
        }
      } else {
        const companyList = await this.getCompanyList();

        const deviceList = [];
        const list = await this.$searchDevice(1, 500, '', this.searchValue2);
        if (list) {
          for (let i = 0; i < list.length; i++) {
            const p = list[i];

            if (this.scope === 4 && p.companyID !== this.currentParentCompanyID) {
              continue;
            }

            const device = {
              id: p.deviceID,
              name: p.deviceName,
              alias: p.deviceAlias,
              pID: p.companyID,
              pName: null,
              pAlias: null,
              folder: false,
              isOpen: true,
              isSelected: false,
              children: [],
            };
            deviceList.push(device);
          }
        }

        const finalCompanyList = [];
        for (let i = 0; i < companyList.length; i++) {
          for (let j = 0; j < deviceList.length; j++) {
            if (companyList[i].id === deviceList[j].pID) {
              deviceList[j].pName = companyList[i].name;
              deviceList[j].pAlias = companyList[i].alias;
              companyList[i].children.push(deviceList[j]);
            }
          }
          if (companyList[i].children.length > 0) {
            companyList[i].folder = true;
            finalCompanyList.push(companyList[i]);
          }
        }
        this.treeData.children = finalCompanyList;
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/include/TreeView.vue